import { getHealthCheck } from '@repo/api-portal-sdk/gen'
import type { RouteSdkOptions } from '@repo/ssr'

export type PortalHealthStatus = 'healthy' | 'unavailable'

export async function loadStatus(sdkOptions: RouteSdkOptions) {
	try {
		const response = await getHealthCheck(sdkOptions)
		return response.data === 'Healthy' ? 'healthy' : 'unavailable'
	} catch (error) {
		if (sdkOptions.signal?.aborted) {
			throw error
		}

		return 'unavailable'
	}
}
